const collegeConfig = {
  name: "Marwari College, Darbhanga",
  tagline: "(A Constituent Unit of L.N. Mithila University, Darbhanga)",
  email: "marwaricollegedarbhanga@gmail.com",
  website: "www.marwaricollege.ac.in",
  logo: "/logo.png", // Use public/logo.png or full URL
  certificateTitle: "BONAFIDE CERTIFICATE",
  signatureLine: "Principal / H.O.D.",
};

export default collegeConfig;